// Material Kit 2 React pages
import Exterior from "pages/Albums/exterior";

export default function ExteriorPage() {
  return <Exterior />;
}
